import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=fed7a0c4&scoped=true"
import script from "./postList.vue?vue&type=script&lang=js"
export * from "./postList.vue?vue&type=script&lang=js"
import style0 from "./postList.vue?vue&type=style&index=0&id=fed7a0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7a0c4",
  null
  
)

export default component.exports